import { RouteRecordRaw } from "vue-router";

export const OpenRoutes: RouteRecordRaw[] = [
    {
        path: "/",
        redirect: "/login",
    },
    {
        path: "/test",
        name: "test",
        component: () => import("../../modules/common/pages/TestPage.vue"),
    },
    {
        path: "/login",
        name: "login",
        component: () => import("../../modules/common/pages/LoginComponent.vue"),
    },
    {
        path: "/acceptor-auth",
        name: "acceptor-auth",
        component: () => import("../../modules/common/pages/acceptor-auth.vue"),
    },
    {
        path: "/reset-password",
        name: "reset-password",
        component: () => import("../../modules/common/pages/reset-password.vue"),
    },
    { path: '/:pathMatch(.*)*', redirect: '/404' },
    {
        path: "/404",
        name: "404",
        component: () => import("../../modules/common/pages/404Page.vue"),
    },
];